import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteCommentSuccess",
  style: {"z-index":"1600"},
  tabindex: "-1",
  "aria-labelledby": "deleteCommentSuccess",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "text-center my-4"
}
const _hoisted_8 = {
  key: 1,
  class: "text-center my-4"
}
const _hoisted_9 = { class: "modal-footer d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import { ERROR_STATUS_HAS_CHANGED, RECORD_NOT_FOUND } from '@/constants/index'
import Button from '@/components/button/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  isDelete: {
    type: Object,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('deleteCommentTitle')), 1),
          _hoisted_6
        ]),
        (__props.isDelete?.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(translate)('commentDeleted')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (__props.isDelete?.message_code === _unref(ERROR_STATUS_HAS_CHANGED))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", null, _toDisplayString(_unref(translate)(_unref(ERROR_STATUS_HAS_CHANGED) + '_1')), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(translate)(_unref(ERROR_STATUS_HAS_CHANGED) + '_2')), 1)
                  ], 64))
                : (__props.isDelete?.message_code === _unref(RECORD_NOT_FOUND))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(translate)('commentDeleted')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_unref(translate)('CN10failedDel')), 1)
                    ], 64))
            ])),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(Button, {
            title: _unref(translate)('close'),
            type: "secondary",
            "data-bs-dismiss": "modal",
            class: "me-2"
          }, null, 8, ["title"])
        ])
      ])
    ])
  ]))
}
}

})